import { CareProType } from "Components/CareProSearchDropdown/types";
import { DeeplinkParams } from "Screens/ManageCareRecipientB2C/ManageCareRecipient";
import { Visit } from "../../../@types/PricingModels";
import  { UpdateVisitProps } from "../DialogCompUpdateVisit";

export enum DIALOG_TYPE {
  NEW_VISIT = 1,
  VISIT_DETAILS = 2,
  ADDITIONAL_REQUIREMENTS = 3,
  MEDICAL_ESCORT_DETAILS = 4,
  PATIENT_DECLARATION = 5,
  PREFERRED_CARE_PROS = 8,
}

export type PayloadVisitDialog = {
  visit: any;
  type: DIALOG_TYPE;
  isUpdate?: boolean;
  anchor: any;
  closeCallback: Function;
  updateCallback: Function;
  deeplinkParams?: DeeplinkParams;
};

export enum VIEW_TYPE {
  DEFAULT = 1,
  CUSTOM_REPEAT = 2,
  ADDITIONAL_DETAILS = 3,
  UPDATE_VISIT = 4,
  CANCEL_VISIT = 5,
  MED_ESCORT_DETAILS = 6,
  PATIENT_DECLARATION = 7,
  PREFERRED_CARE_PROS = 8,
}

export interface VisitRepeatMode {
  is_custom: boolean;
  repeat_count: number;
  repeat_type: string; // 'no-repeat', 'day', 'week', 'month'
  repeat_on?: number[]; // if week selected -> repeat day indexes 0,1,2 ...
  custom_dates?: Date[]; // custom dates for repeat_type = day

  is_ending_exact_date?: boolean;
  ends_on_date?: Date; // undefined means ends after default 1 week
  ends_after?: number; // default 7
  ends_after_type?: string; // occurrences, days, weeks

  repeat_on_month_day?: boolean; // repeat on 22nd of each month
}

export type VisitDialogProps = {
  coId?: string;
  moveToListView?: Function;
  region?: string;
};

export type VisitDialogState =  {
  _dialogtype: DIALOG_TYPE;
  _viewtype: VIEW_TYPE;

  // open indicates whether the dialog is open
  open: boolean;

  // used internally to fix the animation
  // animations don't work immediately setting display: none to display: block
  _open: boolean;

  _repeatModes: string[];
  _repeatMode: VisitRepeatMode;

  _visit: any;
  _visitsCount: number;

  current_selected_preferred_care_pros: any;

  // Existing visits are view only (disable editing when view only)
  _isReadOnly?: boolean;

  _isUpdating?: boolean;
  _updatingVisitsTitle?: string; // additional title when updating multiple visits together

  _disableAnim?: boolean;

  _showConfirmation?: boolean;

  _updateVisitProps?: UpdateVisitProps;

  _closeCallbackFrom: string;
  _renderedVisitFromBigCalendar: any;
  _eventTypeFromBigCalendar: string;
  _eventKeyFromBigCalendar: boolean;
  _currentVisitFromVisitDraftListView: any;
  _isApplyToAllFromVisitDraftListView: boolean;
  _adlHasErrorOnce: boolean;

  // show validation errors for new visit(s)
  _showErrors?: string;
};

export type VisitDialogStatePropsType = {
  crInfo?: any;
  data?: any;
  preferred_cps_list_by_service: {
    home_personal_care?: Array<CareProType>;
    home_therapy?: Array<CareProType>;
    home_medical?: Array<CareProType>;
  },
  previousVisit: any;
  states: any[];
  vwoId?: string;
};

export type VisitDialogConnectPropsType = {

};

export type VisitDialogFullPropsType = VisitDialogProps & VisitDialogStatePropsType & VisitDialogConnectPropsType;
